import type { Step } from '../../../../types';
import {
  LoanOverview,
  Step1,
  Step2,
  Step3,
  Step4,
  Step5,
  Step6,
  Step7,
  Step8,
  Step9,
} from '../steps';

export const steps = [
  {
    name: 'Step 1: About the loan',
    title: 'About the loan',
    component: Step1,
  },
  {
    name: 'Step 2: Share e-skat data',
    title: 'Share e-skat data',
    component: Step2,
  },
  {
    name: 'Step 3: Your household',
    title: 'Your household',
    component: Step3,
  },
  {
    name: 'Step 4: Your home',
    title: 'Your home',
    component: Step4,
  },
  {
    name: 'Step 5: Your consumption',
    title: 'Your consumption',
    component: Step5,
  },
  {
    name: 'Step 6: Your finances',
    title: 'Your finances',
    component: Step6,
  },
  {
    name: 'Step 7: Your existing debt',
    title: 'Your existing debt',
    component: Step7,
  },
  {
    name: 'Step 9: Approve with MitID',
    title: 'Approve with MitID',
    component: Step9,
    customNextStepIndicator: 'Send application',
  },
] satisfies Step[];

export const CoApplicantStep = {
  name: 'Step 8: Co-applicant',
  title: 'Co-applicant',
  component: Step8,
  customNextStepIndicator: 'Send application',
} satisfies Step;

export const LoanOverviewStep = {
  name: 'Step 7b: Review your application',
  title: 'Review your application',
  component: LoanOverview,
  customNextStepIndicator: 'Send application',
} satisfies Step;
